import { create } from "zustand";

// Global modal state so any page can open the teacher modals without prop
// drilling. Payloads carry real backend teacher objects (AccountMini shape:
// uuid + full_name + department + subjects + portrait_url + ...).
const useModalsStore = create((set) => ({
  teacherList: null, // { title, teachers: [teacherObj, ...], focusStandardUuid? }
  teacherOverview: null, // { teacher, focusStandardUuid? }

  openTeacherList: (payload) => set({ teacherList: payload }),
  closeTeacherList: () => set({ teacherList: null }),

  openTeacherOverview: (payload) => set({ teacherOverview: payload }),
  closeTeacherOverview: () => set({ teacherOverview: null }),
}));

export default useModalsStore;
